import React from 'react'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'
import PropTypes from 'prop-types'

import Row from '../Details/Row'

const DetailsLanguages = ({ languages, staticData }) => {
  const rawLanguages = toJS(languages)

  return Array.isArray(rawLanguages) && rawLanguages.length > 0 ? (
    rawLanguages.map((item, index) => {
      let label = ''
      if (index === 0) {
        label = 'Languages'
      }
      const proficiencyId = item.languageToUser.languageProficiencyId
      const proficiency = staticData.names.languageProficiencies[proficiencyId]
      return (
        <Row
          key={item.id}
          label={label}
          text={`${item.name} (${proficiency})`}
          copiable
        />
      )
    })
  ) : (
    <Row label='Languages' />
  )
}

DetailsLanguages.propTypes = {
  languages: PropTypes.array,
  staticData: PropTypes.object
}

export default inject('staticData')(observer(DetailsLanguages))
